import React from 'react';
import Container from 'components/common/layout/container/Container';
import Item from 'components/common/layout/item/Item';
import {Trans} from 'lib/i18n';
import Title from 'components/common/typeography/title/Title';
import WidgetDisclaimer from 'components/common//widget-disclaimer/WidgetDisclaimer';
import Text from 'components/common/typeography/text/Text';
import {withWidgetProducts} from 'components/products';
import CalculatorForm from './components/calculator-form/CalculatorForm';
import {withApiKeyValidation} from 'components/validation/withApiKey';
import {useAuditSession} from 'lib/illustration-audit';

function CalculatorPage(props) {
  useAuditSession({source: 'widget'});

  return (
    <Container spacing={3} style={{margin: '0 auto', width: '100%', maxWidth: 1600, padding: '0 8px'}}>
      <Item xs={12}>
        <Container>
          <Item xs={12}>
            <Title variant="h4" style={{textAlign: 'center'}}>
              <Trans i18nKey="calculator.title" />
            </Title>
          </Item>
          <Item xs={12} className={'subtitle'} style={{marginTop: '0px', paddingTop: '0px', paddingBottom: '0px'}}>
            <Title variant="subtitle2" style={{textAlign: 'left'}}>
              <Trans i18nKey="calculator.subtitle" />
            </Title>
          </Item>

          <CalculatorForm />

          <Item xs={12}>
            <WidgetDisclaimer>
              <Text variant="body2" style={{textAlign: 'left'}}>
                <Trans i18nKey="calculator.disclaimer" />
              </Text>
            </WidgetDisclaimer>
            <WidgetDisclaimer>
              <Title variant="body2" style={{textAlign: 'left', marginTop: '5px'}}>
                <Trans i18nKey="calculator.powered by" />
              </Title>
            </WidgetDisclaimer>
          </Item>
        </Container>
      </Item>
    </Container>
  );
}

export default withApiKeyValidation(withWidgetProducts(CalculatorPage));
